import { render, staticRenderFns } from "./BudgetLabel.vue?vue&type=template&id=10701796&"
import script from "./BudgetLabel.vue?vue&type=script&lang=ts&"
export * from "./BudgetLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports